import { productionCodeRepo } from "./productionCode.repo";
import {
  DownloadProductionCodeRequestFilePayload,
  ProductionCodeRequestApprovalPayload,
  ProductionCodeRequestFormPayload,
  ProductionCodeRequestListPayload,
  ProdukcioniKodIzvodPayload,
} from "./productionCode.types";

class ProductionCodeService {
  getAllProductionCodeRequest = (payload: ProductionCodeRequestListPayload) => {
    return productionCodeRepo.getAllProductionCodeRequest(payload);
  };

  createProductionCodeRequest = (payload: ProductionCodeRequestFormPayload) => {
    return productionCodeRepo.createProductionCodeRequest(payload);
  };

  downloadRequestProductionCodes = (
    payload: DownloadProductionCodeRequestFilePayload
  ) => {
    return productionCodeRepo.downloadRequestProductionCodes(payload);
  };

  downloadRequestProformaInvoice = (
    payload: DownloadProductionCodeRequestFilePayload
  ) => {
    return productionCodeRepo.downloadRequestProformaInvoice(payload);
  };

  acceptProductionCodeRequest = (
    payload: ProductionCodeRequestApprovalPayload
  ) => {
    return productionCodeRepo.acceptProductionCodeRequest(payload);
  };

  declineProductionCodeRequest = (
    payload: ProductionCodeRequestApprovalPayload
  ) => {
    return productionCodeRepo.declineProductionCodeRequest(payload);
  };

  getProductionCodeRequestFormData = (id: number | null) => {
    return productionCodeRepo.getProductionCodeRequestFormData(id);
  };

  getProductionCodeRequestDetails = (id: number | null) => {
    return productionCodeRepo.getProductionCodeRequestDetails(id);
  };

  getAllProdukcioniKodoviListaIzvoda = (
    payload: ProdukcioniKodIzvodPayload
  ) => {
    return productionCodeRepo.getAllProdukcioniKodoviListaIzvoda(payload);
  };
}

export const productionCodeService = new ProductionCodeService();
